(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-article"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    const url = btn.getAttribute('data-copy-link');
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => {
      btn.classList.add('is-copied');
      setTimeout(() => btn.classList.remove('is-copied'), 1500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-best]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var step = function () { return Math.max(240, Math.round(track.clientWidth * 0.8)); };
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-blog"] && !Shopify.designMode) return;
  try {
    
  class MmgBlogList extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-load-more]');
      if (this.btn) this.btn.addEventListener('click', (e) => { e.preventDefault(); this.loadMore(); });
    }
    async loadMore() {
      const url = this.btn.getAttribute('href'); if (!url) return;
      this.btn.classList.add('is-loading');
      try {
        const res = await fetch(url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = this.querySelector('[data-grid]');
        doc.querySelectorAll('[data-grid] > .mmg-blog__card').forEach((c) => grid.appendChild(document.importNode(c, true)));
        const next = doc.querySelector('[data-load-more]');
        if (next) { this.btn.setAttribute('href', next.getAttribute('href')); this.btn.classList.remove('is-loading'); }
        else { const w = this.btn.closest('.mmg-blog__pagination'); if (w) w.remove(); }
      } catch (e) { this.btn.classList.remove('is-loading'); console.error(e); }
    }
  }
  if (!customElements.get('mmg-blog-list')) customElements.define('mmg-blog-list', MmgBlogList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-cart"] && !Shopify.designMode) return;
  try {
    
  class MmgCart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const plus = e.target.closest('[data-plus]');
        const minus = e.target.closest('[data-minus]');
        const remove = e.target.closest('[data-remove]');
        if (!plus && !minus && !remove) return;
        const item = e.target.closest('[data-item]');
        if (!item) return;
        const key = item.getAttribute('data-key');
        const current = parseInt(item.querySelector('[data-qty]').textContent, 10) || 1;
        let qty = current;
        if (plus) qty = current + 1;
        if (minus) qty = current - 1;
        if (remove) qty = 0;
        this.change(item, key, qty);
      });
    }
    async change(item, key, quantity) {
      item.classList.add('is-loading');
      try {
        const res = await fetch(this.getAttribute('data-cart-url') + '/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (!res.ok) throw new Error('cart change failed');
        window.location.reload();
      } catch (err) {
        item.classList.remove('is-loading');
        console.error(err);
      }
    }
  }
  if (!customElements.get('mmg-cart')) customElements.define('mmg-cart', MmgCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-collection"] && !Shopify.designMode) return;
  try {
    
  // tri natif : submit auto au changement
  class MmgCollection extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-load-more]');
      if (this.btn) this.btn.addEventListener('click', (e) => { e.preventDefault(); this.loadMore(); });
    }
    async loadMore() {
      const url = this.btn.getAttribute('href');
      if (!url) return;
      this.btn.classList.add('is-loading');
      try {
        const res = await fetch(url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = this.querySelector('[data-grid]');
        const newCards = doc.querySelectorAll('[data-grid] > .mmg-card');
        newCards.forEach((c) => grid.appendChild(document.importNode(c, true)));
        const nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn) { this.btn.setAttribute('href', nextBtn.getAttribute('href')); this.btn.classList.remove('is-loading'); }
        else { const wrap = this.btn.closest('.mmg-coll__more'); if (wrap) wrap.remove(); }
      } catch (e) { this.btn.classList.remove('is-loading'); console.error(e); }
    }
  }
  if (!customElements.get('mmg-collection')) customElements.define('mmg-collection', MmgCollection);

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-sort]');
    if (sel) sel.closest('[data-sort-form]').submit();
  });

  class MmgSeoToggle extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('[data-seo-body]');
      const btn = this.querySelector('[data-seo-toggle]');
      const label = this.querySelector('[data-seo-label]');
      if (!body || !btn) return;
      // masque le bouton si le contenu est court
      requestAnimationFrame(() => { if (body.scrollHeight <= 240) { btn.style.display = 'none'; const f = body.querySelector('[data-seo-fade]'); if (f) f.style.display = 'none'; } });
      btn.addEventListener('click', () => {
        const open = body.classList.toggle('is-open');
        btn.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? 'Réduire' : 'Lire la suite';
      });
    }
  }
  if (!customElements.get('mmg-seo-toggle')) customElements.define('mmg-seo-toggle', MmgSeoToggle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-header"] && !Shopify.designMode) return;
  try {
    
  class MMGHeader extends HTMLElement {
    connectedCallback() {
      const drawer = this.querySelector('[data-drawer]');
      const open = this.querySelector('[data-drawer-open]');
      const closers = this.querySelectorAll('[data-drawer-close]');
      if (open && drawer) {
        const show = () => { drawer.hidden = false; requestAnimationFrame(() => drawer.classList.add('is-open')); document.body.style.overflow = 'hidden'; };
        const hide = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(() => { drawer.hidden = true; }, 280); };
        open.addEventListener('click', show);
        closers.forEach((c) => c.addEventListener('click', hide));
      }
    }
  }
  if (!customElements.get('mmg-header')) customElements.define('mmg-header', MMGHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    // galerie
    var thumbs = root.querySelectorAll('[data-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-thumb');
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === i); });
      });
    });
    // quantité +/-
    var qtyInput = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    // offres par lot -> présélection quantité (remise réelle appliquée au panier par la Function)
    var bundles = root.querySelectorAll('[data-bundle]');
    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        if (qtyInput) qtyInput.value = Math.max(1, parseInt(b.getAttribute('data-qty'), 10) || 1);
      });
    });
    // variants
    var variantId = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    root.querySelectorAll('[data-variant]').forEach(function (v) {
      v.addEventListener('click', function () {
        root.querySelectorAll('[data-variant]').forEach(function (x) { x.classList.remove('is-active'); });
        v.classList.add('is-active');
        if (variantId) variantId.value = v.getAttribute('data-variant');
        var m = v.getAttribute('data-price');
        if (priceEl && m) priceEl.textContent = m;
        if (stickyPrice && m) stickyPrice.textContent = m;
      });
    });
    // timeline dates
    function fmt(d) { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }); }
    var now = new Date();
    var d1 = new Date(now); d1.setDate(d1.getDate() + 1);
    var d2 = new Date(now); d2.setDate(d2.getDate() + 4);
    var e0 = root.querySelector('[data-d0]'); var e1 = root.querySelector('[data-d1]'); var e2 = root.querySelector('[data-d2]');
    if (e0) e0.textContent = fmt(now);
    if (e1) e1.textContent = fmt(d1);
    if (e2) e2.textContent = fmt(d2);
    // barre sticky : apparait quand la colonne d'achat sort du viewport
    var sticky = root.querySelector('[data-sticky]');
    var buy = root.querySelector('[data-buy]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var form = root.querySelector('.mmg-pdp__form');
    if (stickyAdd && form) stickyAdd.addEventListener('click', function () {
      var submit = form.querySelector('[name="add"]');
      if (submit) submit.click();
    });
    if (sticky && buy) {
      sticky.hidden = false;
      var onScroll = function () {
        var r = buy.getBoundingClientRect();
        sticky.classList.toggle('is-visible', r.bottom < 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-recommendations"] && !Shopify.designMode) return;
  try {
    
  class MMGRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.mmg-reco__grid')) return; // déjà peuplé (SSR)
      var url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('mmg-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }
  }
  if (!customElements.get('mmg-recommendations')) customElements.define('mmg-recommendations', MMGRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-search"] && !Shopify.designMode) return;
  try {
    
  class MmgSearchResults extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-load-more]');
      if (this.btn) this.btn.addEventListener('click', (e) => { e.preventDefault(); this.loadMore(); });
    }
    async loadMore() {
      const url = this.btn.getAttribute('href');
      if (!url) return;
      this.btn.classList.add('is-loading');
      try {
        const res = await fetch(url);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = this.querySelector('[data-grid]');
        doc.querySelectorAll('[data-grid] > .mmg-card').forEach((c) => grid.appendChild(document.importNode(c, true)));
        const nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn) { this.btn.setAttribute('href', nextBtn.getAttribute('href')); this.btn.classList.remove('is-loading'); }
        else { const w = this.btn.closest('.mmg-search__more'); if (w) w.remove(); }
      } catch (e) { this.btn.classList.remove('is-loading'); console.error(e); }
    }
  }
  if (!customElements.get('mmg-search-results')) customElements.define('mmg-search-results', MmgSearchResults);
  document.addEventListener('change', (e) => { const s = e.target.closest('[data-sort]'); if (s) s.closest('[data-sort-form]').submit(); });

  } catch(e) { console.error(e); }
})();
})();
